<span *ngIf="loading" id="spinner-span">
  <mat-spinner [diameter]="loadingSpinnerDiameter" [strokeWidth]="loadingSpinnerStrokeWidth"></mat-spinner>
</span>

<span #buttonWrapper [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip" (click)="onWrapperClick($event)" (keydown.enter)="onWrapperClick($event)" (keydown.space)="onWrapperClick($event)" tabindex="0" role="button" class="d-block">

  <ng-container [ngSwitch]="buttonType">

    <button
      *ngSwitchCase="'ng-content-button'"
      mat-flat-button
      [type]="type"
      [color]="theme"
      [disabled]="disabled"
      [disableRipple]="true"
      [ngClass]="ngClass"
    >
      <ng-container *ngTemplateOutlet="contentOutlet"></ng-container>
    </button>

    <button
      *ngSwitchCase="'text-icon-button'"
      mat-raised-button
      [type]="type"
      [color]="theme"
      [disabled]="disabled"
      [disableRipple]="true"
      [ngClass]="ngClass"
    >
      <app-icon
        class="text-icon"
        [outlined]="iconOutlined"
        [useSymbol]="useSymbol"
        [color]="iconColor"
        [size]="iconSize"
        [hoverColor]="iconHoverColor"
        [config]="iconConfig"
        *ngIf="!iconRight"
      >
        {{ icon }}
      </app-icon>
      <span class="icon-text" [ngClass]="{'icon-text-right': iconRight}"><ng-container *ngTemplateOutlet="contentOutlet"></ng-container></span>
      <app-icon
        class="text-icon"
        [outlined]="iconOutlined"
        [useSymbol]="useSymbol"
        [color]="iconColor"
        [size]="iconSize"
        [hoverColor]="iconHoverColor"
        [config]="iconConfig"
        *ngIf="iconRight"
      >
        {{ icon }}
      </app-icon>
      <app-badge *ngIf="badgeCount !== undefined">{{ badgeCount }}</app-badge>
    </button>

    <button
      *ngSwitchCase="'tab-button'"
      mat-flat-button
      [type]="type"
      [color]="theme"
      [disabled]="disabled"
      [disableRipple]="true"
      [ngClass]="ngClass"
      tabindex="0"
    >
      <app-icon
        *ngIf="icon"
        [color]="iconColor"
        [useSymbol]="useSymbol"
        [hoverColor]="iconHoverColor"
        [outlined]="iconOutlined"
        [config]="iconConfig"
        >{{ icon }}</app-icon
      >
      <ng-container *ngTemplateOutlet="contentOutlet"></ng-container>
    </button>

  </ng-container>
</span>


<ng-template #contentOutlet>
  <ng-content></ng-content>
</ng-template>
